module.exports = __webpack_public_path__ + "img/6.61526a7c.png";